<script>
	const Q = require('q');
	const productService = require('services/productService');
	const metadata = require('core/metadata');
	const model = require('model/model');

	module.exports = {
		components: {
			'promotional-collection-panel': require('components/promotional-collection-panel.vue').default
		},
		data() {
			return {
				products: null
			};
		},
		modelData: ['userContext', 'promoId'],
		computed: {
			spotlightNode() {
				let spotlightId = this.promoId;
				let node = null;

				if (spotlightId && metadata.allNodesById['_' + spotlightId]) {
					node = metadata.allNodesById['_' + spotlightId];
				}

				return node;
			}
		},
		watch: {
			spotlightNode(p) {
				if (p && p.products && p.products.length) {
					this.spotlightProducts = null;
					let pids = p.products;
					let prms = pids.map(pid => {
						return productService.get(pid);
					});

					Q.all(prms)
						.then(products => {
							this.products = products;
						})
						.done();
				}
			}
		},
		methods: {
			onProductClick() {
				model.set('promoLink', this.promoId);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';
	@import 'mixins/flexbox';

	.promotional-collection {
		.main-header .main-header-back {
			margin: 0.5rem 0;
		}
	}

	@media only screen and (min-width: $bp-width-med) {
	}
</style>
<template>
	<main
		id="content"
		class="main promotional-collection">
		<header class="main-header">
			<div class="wrapper">
				<a
					class="main-header-back"
					href="/find-content">
					&larr; Back to Find Content
				</a>
			</div>
		</header>
		<div class="main-content wrapper">
			<section>
				<promotional-collection-panel
					:node="spotlightNode"
					:products="products"
					:on-product-click="onProductClick">
				</promotional-collection-panel>
			</section>
		</div>
	</main>
</template>
